var render = function render(){var _vm=this,_c=_vm._self._c;return _c('SpringSpinner',{tag:"component",attrs:{"animation-duration":_vm.duration,"color":_vm.color,"size":_vm.size}})
}
var staticRenderFns = []

export { render, staticRenderFns }